import { render, staticRenderFns } from "./ColorPickerPopover.vue?vue&type=template&id=24bbfd04&scoped=true"
import script from "./ColorPickerPopover.vue?vue&type=script&lang=js"
export * from "./ColorPickerPopover.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerPopover.vue?vue&type=style&index=0&id=24bbfd04&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bbfd04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24bbfd04')) {
      api.createRecord('24bbfd04', component.options)
    } else {
      api.reload('24bbfd04', component.options)
    }
    module.hot.accept("./ColorPickerPopover.vue?vue&type=template&id=24bbfd04&scoped=true", function () {
      api.rerender('24bbfd04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/ColorPickerPopover.vue"
export default component.exports